import { render } from "./AddEditProduct.vue?vue&type=template&id=441d37dc"
import script from "./AddEditProduct.vue?vue&type=script&lang=js"
export * from "./AddEditProduct.vue?vue&type=script&lang=js"

import "./AddEditProduct.vue?vue&type=style&index=0&id=441d37dc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__